import { render, staticRenderFns } from "./AddToContact.vue?vue&type=template&id=3e3fc6d4"
import script from "./AddToContact.vue?vue&type=script&lang=js"
export * from "./AddToContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports